import api from "./api";
import { ContactForm } from "@/types";

/**
 * Service for managing Contact Form submissions.
 */
export const contactService = {
  /**
   * Fetch all contact forms from the API.
   */
  async getContacts(params?: any): Promise<any> {
    const response = await api.get("/contact-forms", { params });
    // The interceptor in api.ts returns response.data.data directly.
    // When paginated, this usually contains { docs, totalDocs, limit, page, ... }
    return response as any;
  },

  /**
   * Update contact status (e.g. mark as read).
   */
  async updateContactStatus(id: string, status: "new" | "read" | "replied"): Promise<ContactForm> {
    const response = await api.patch(`/contact-forms/${id}`, { status });
    return response as any;
  },

  /**
   * Delete a contact form submission.
   */
  async deleteContact(id: string): Promise<void> {
    await api.delete(`/contact-forms/${id}`);
  },

  /**
   * Submit a new contact form.
   */
  async submitContactForm(data: Partial<ContactForm>): Promise<ContactForm> {
    const response = await api.post("/contact-forms", data);
    return response as any;
  },
};
